import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { StaticRouterLinks } from "../utils/StaticRouterLinks";
import { isNullOrUndefined } from "../utils/utils";
import { ImageSrc } from "../utils/ImageSrc";
import { Dialog, SwipeableDrawer } from "@mui/material";
import PrimaryButton from "./Button/PrimaryButton";
export let handleCurrentProgress;
export let handleLogOut;
export default function Header({ clientDetails, setDialogContent, setOpen }) {
  const navigate = useNavigate();
  const location = useLocation();
  // const [open, setOpen] = useState(false);

  handleLogOut = () => {
    let loacalStorageKeys = ["token", "ucc"];
    loacalStorageKeys?.forEach((key) => localStorage.removeItem(key));
    sessionStorage?.clear();
    navigate(StaticRouterLinks?.home);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDialogLogOut = () => {
    setOpen(true);
    setDialogContent(
      <form
        id="draggable-dialog-title"
        className=" flex flex-col items-center gap-[27px] md:gap-[40px] px-[14px] md:px-[54px] py-6 md:py-[44px] md:w-[440px] relative "
      >
        <span className="text-lg ">Do you want to Logout ?</span>

        <PrimaryButton
          size={"large"}
          name={"Logout"}
          height={"50px"}
          borderRadius={"10px"}
          backgroundColor={"#F1414B"}
          // type="submit"
          handleOnClick={handleLogOut}
          handleTouchStart={handleLogOut}
        />

        <span
          className="text-[16px] text-pkt-subheading cursor-pointer"
          onClick={handleClose}
          onTouchStart={handleClose}
        >
          Cancel
        </span>
      </form>
    );
  };

  return (
    <>
      <div className="flex flex-row justify-between items-center w-screen h-[86px] lg:h-[74px] px-2 md:px-[38px] z-20 fixed bg-white shadow-[0_0px_14px_0px_rgba(0,0,0,0.06)] lg:shadow-none">
        <div className="flex flex-row basis-1/3 gap-[10px] cursor-pointer">
          <div
            className="flex flex-row justify-center items-center gap-1 w-[87px] h-[37px] pl-[7px] pr-[10px] py-2 rounded-full border border-pkt-EAEAEA"
            onClick={handleDialogLogOut}
          >
            <img
              src={ImageSrc?.headerImages?.logout}
              alt="logout"
              className="w-[14px]"
            />

            <span className="text-sm font-medium">Logout</span>
          </div>
        </div>
        {location.pathname !== StaticRouterLinks.kycCompleted && (
          <div className="flex flex-row justify-center items-center w-full">
            <img
              src={ImageSrc?.headerImages?.pace}
              alt="pace-logo-header"
              // className="w-[142px]"
            />
          </div>
        )}

        <div className="flex flex-row justify-end items-center basis-1/3 ">
          <div className="flex items-center justify-center w-[34px] h-[34px] p-0.5 border-4 bg-pkt-secondary rounded-full ">
            {clientDetails?.Name?.charAt(0)}
          </div>
        </div>
      </div>
    </>
  );
}
